export const CAROUSEL_PLACE = 'below_listing';
